import { render, staticRenderFns } from "./RecoveryAtIdE.html?vue&type=template&id=06cb13d2&scoped=true&"
import script from "./RecoveryAtIdE.vue?vue&type=script&lang=js&"
export * from "./RecoveryAtIdE.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryAtIdE.scss?vue&type=style&index=0&id=06cb13d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb13d2",
  null
  
)

export default component.exports